import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const QuizIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.02051 0.0839844H1.97884C0.949675 0.0839844 0.0830078 0.950651 0.0830078 1.97982V9.02148C0.0830078 10.0507 0.949675 10.9173 1.97884 10.9173H7.66634L10.9163 7.66732V1.97982C10.9163 0.950651 10.0497 0.0839844 9.02051 0.0839844ZM9.83301 7.12565H9.02051C7.99134 7.12565 7.12467 7.99232 7.12467 9.02148V9.83398H2.14134C1.59967 9.83398 1.16634 9.40065 1.16634 8.85898V2.14232C1.16634 1.60065 1.59967 1.16732 2.14134 1.16732H8.91217C9.45384 1.16732 9.88717 1.60065 9.88717 2.14232V7.12565H9.83301ZM7.23301 3.44232L8.04551 4.25482L4.79551 7.50482L2.89967 5.60898L3.71217 4.79648L4.79551 5.87982L7.23301 3.44232Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export default QuizIcon;
